import { canNavigate } from '@/plugins/acl/routeProtection'
import store from '@/store'
import Vue from 'vue'
import VueRouter from 'vue-router'
import accessRoutes from './routing/accessRoutes'
import authRoutes from './routing/authRoutes'
import baseRoutes from './routing/baseRoutes'
import coworkerRoutes from './routing/coworkerRoutes'
import satchelRoutes from './routing/satchelRoutes'
import usersRoutes from './routing/usersRoutes'

Vue.use(VueRouter)

const routes = [
  ...baseRoutes,
  ...authRoutes,
  ...coworkerRoutes,
  ...accessRoutes,
  ...satchelRoutes,
  ...usersRoutes,
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

const auth = {
  loggedIn() {
    return store.getters['auth/getToken'] !== '' || localStorage.getItem('token') !== null
  },
}

router.beforeEach((to, _, next) => {
  if (to.meta.requiresAuth) {
    if (!canNavigate(to)) {
      // Redirect to login if not logged in

      if (!auth.loggedIn()) {
        return next({ name: 'auth-login', query: { marketplace: to.query.marketplace } })
      }

      // If logged in => not authorized
      return next({ name: 'not-authorized' })
    }
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && auth.loggedIn()) {
    next('/')
  }

  return next()
})

export default router
